module.exports = __webpack_public_path__ + "img/revo_1kl.0c9f6fe1.jpg";